import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/mnt/cache/teamcity-agent/work/c5c1aadee301441a/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/mnt/cache/teamcity-agent/work/c5c1aadee301441a/src/layouts/empty.vue").then(m => m.default || m))
}